import React from 'react';
import {useControllerProps} from '../../ControllerContext';
import {OrderDetailsSection, OrderDetailsSectionLayout} from '../OrderDetailsSection/OrderDetailsSection';
import settingsParams from '../../../settingsParams';
import {useSettings} from 'yoshi-flow-editor-runtime/tpa-settings/react';
import {useTranslation} from 'yoshi-flow-editor-runtime';

export enum ShippingInfoDataHook {
  root = 'ShippingInfoDataHook.root',
  label = 'ShippingInfoDataHook.label',
  shippingAddress = 'ShippingInfoDataHook.shippingAddress',
}

export function ShippingInfo() {
  const {get} = useSettings();
  const {t} = useTranslation();
  const {shippingAddress} = useControllerProps().thankYouPageStore;

  const getShippingColumnTitle = () => {
    const customTitle = get(settingsParams.THANK_YOU_PAGE_SHIPPING_ADDRESS_LABEL);
    if (customTitle) {
      return customTitle;
    }
    return t('thankYou.SHIPPING_LABEL');
  };

  return (
    <OrderDetailsSection dataHook={ShippingInfoDataHook.root} layout={OrderDetailsSectionLayout.Vertical}>
      <OrderDetailsSection.Title dataHook={ShippingInfoDataHook.label}>
        {getShippingColumnTitle()}
      </OrderDetailsSection.Title>
      <OrderDetailsSection.Content dataHook={ShippingInfoDataHook.shippingAddress}>
        {shippingAddress}
      </OrderDetailsSection.Content>
    </OrderDetailsSection>
  );
}
